/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { AppConfigService } from "../../app-config/app-config.service";
import { ParticipantDTO } from "app/core/models/participant-dto";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  	providedIn: 'root'
})

export class HttpAddParticipantService {

    public readonly URL: string;

	constructor(
		private http: HttpClient,
        private configSvc: AppConfigService
	) {
        this.URL = this.configSvc.settings.nodeUrl + 'participants';
    }

    public addParticipant$(
        newParticipantID: string,
        newParticipantName: string,
        newParticipantTargetURL: string,
        newParticipantProtocols: string[]
    ): Observable<ParticipantDTO> {

        const headers = new HttpHeaders({
			'x-api-key': this.configSvc.settings.participantsAPIKey
		});

        const body = {
            "id": newParticipantID,
            "name": newParticipantName,
            "targetUrl": newParticipantTargetURL,
            "supportedProtocols": newParticipantProtocols
        }

        return this.http.post<ParticipantDTO>(
            this.URL,
            body,
            { headers }
        );

    }

}